// extracted by mini-css-extract-plugin
export default {"tableBodyCell":"TableReportInboundOutboundCalls_tableBodyCell__pZZGg","tableContainer":"TableReportInboundOutboundCalls_tableContainer__oIsi4"};